import { warn } from "rtUtils/logger";

const setMediaElementProps = (elm, src, attrs) => {
	Object.entries(attrs)
		.forEach(([key, val]) => {
			if (key in elm) {
				elm[key] = val;
			} else {
				warn(`Cloudinary 3D - unknown "${key}" attr on "${elm}"}`);
			}
		});

	elm.src = src;
};

const appendMediaElement = (tag, src, attrs, parent) => {
	const elm = typeof tag === "string" ? document.createElement(tag) : tag;
	setMediaElementProps(elm, src, attrs);
	parent.appendChild(elm);
	return elm;
};

const updateMediaElement = (tag, src, attrs, parent) => {
	const elm = parent.querySelector(tag);
	setMediaElementProps(elm, src, attrs);
	return elm;
};

export {
	appendMediaElement,
	updateMediaElement,
};
